var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center py-5"},[_c('router-link',{staticClass:"home-link text--primary",attrs:{"to":{name: 'orders'}}},[_c('img',{attrs:{"src":"/img/logo.png","alt":"Jarstol"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }